import { render } from "./Swiper.vue?vue&type=template&id=4158d044&scoped=true"
import script from "./Swiper.vue?vue&type=script&lang=js"
export * from "./Swiper.vue?vue&type=script&lang=js"

import "./Swiper.vue?vue&type=style&index=0&id=4158d044&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4158d044"],['__file',"src/js/components/Swiper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4158d044"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4158d044', __exports__)) {
    api.reload('4158d044', __exports__)
  }
  
  module.hot.accept("./Swiper.vue?vue&type=template&id=4158d044&scoped=true", () => {
    api.rerender('4158d044', render)
  })

}


export default __exports__